module.exports = __webpack_public_path__ + "close.1a93552de905fdb2660a6f413900631a.svg";